import HeaderMachineRegister from 'components/HeaderMachineRegister';
import { useEffect } from 'react';
import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import MachineRegisterFirstStep from './MachineRegisterFirstStep';
import MachineRegisterSecondStep from './MachineRegisterSecondStep';
import MachineRegisterThirdStep from './MachineRegisterThirdStep';
import { resetState } from './slices';
import Wrap from './styles';

const MachineRegister: FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  const stepToPrevious = () => {
    setCurrentStep(currentStep - 1);
  };
  const nextStep = () => {
    currentStep < 3 && setCurrentStep(1 + currentStep);
  };
  const screen = () => {
    switch (currentStep) {
      case 0:
        return <MachineRegisterFirstStep nextStep={nextStep} checked={checked} setChecked={setChecked} />;
      case 1:
        return <MachineRegisterSecondStep nextStep={nextStep} stepToPrevious={stepToPrevious} checked={checked} />;
      case 2:
        return <MachineRegisterThirdStep />;
    }
  };
  return (
    <Wrap>
      <HeaderMachineRegister nextStep={nextStep} currentStep={currentStep} />
      <div className="section">{screen()}</div>
    </Wrap>
  );
};
export default MachineRegister;
